import { useEffect } from "react";
import apiClient from "../business/network/ApiClient";
import { CurrentUser } from "../business/helper/CurrentUser";

/** A tab left open and come back to after this long counts as a new visit. */
export const REVISIT_AFTER_MS = 30 * 60 * 1000;

/**
 * Tells the backend the user is here: once per load, and again when a tab left open for a while
 * comes back into view or focus. Feeds the back-office "Last access" column, so a prompt is no
 * longer the only trace a visit leaves — a user who only read a scheduled answer is seen too.
 *
 * Fire-and-forget: `recordAccess` swallows its own failures, and nothing waits on it.
 */
const useAccessStamp = () => {
  useEffect(() => {
    let lastStampAt = 0;

    const stamp = () => {
      const userId = CurrentUser.GetCurrentUserData()?.userId;
      if (!userId) return;
      lastStampAt = Date.now();
      apiClient.recordAccess(userId);
    };

    const onReturn = () => {
      if (document.visibilityState !== "visible") return;
      if (Date.now() - lastStampAt < REVISIT_AFTER_MS) return;
      stamp();
    };

    stamp();
    document.addEventListener("visibilitychange", onReturn);
    window.addEventListener("focus", onReturn);
    return () => {
      document.removeEventListener("visibilitychange", onReturn);
      window.removeEventListener("focus", onReturn);
    };
  }, []);
};

export default useAccessStamp;
